var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"2","md":"2","lg":"1"}},[_c('sidebar')],1),_c('v-col',{attrs:{"cols":"10","md":"10","lg":"11","xl":"11"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }